<template>
    <div class="community-module">
        <img class="g-img-gap" src="@/assets/images/bg/bg_img_6@3x.jpg" alt="" />
        <div class="community-module-content">
            <ModuleTitle title="社区活动" :type="2"> </ModuleTitle>
            <Text2 v-if="store.indexData.showCommunity2" @showTopic="onShowTopic"></Text2>
            <Text1 v-else @showTopic="onShowTopic"></Text1>
            <FollowList></FollowList>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, getCurrentInstance } from 'vue';
import ModuleTitle from '../module-title/index.vue';
import FollowList from '../follow-list/index.vue';
import { useStore } from '@/store';
import Text1 from './text-1.vue';
import Text2 from './text-2.vue';
import { schemaSingle, openLogin, schemaToPostPublish, schemaSupportMap } from '@q-front-npm/jsbridge';
const store = useStore();
const instance = getCurrentInstance();
const topicConfig: Record<number, { from: string; topic_id: string; topic_title: string }> = {
    1: {
        from: '1',
        topic_id: '403785',
        topic_title: '我的国庆旅行计划',
    },
    2: {
        from: '1',
        topic_id: '403784',
        topic_title: '国庆宅家做点啥',
    },
    3: {
        from: '1',
        topic_id: '403595',
        topic_title: '中秋月光存放站',
    },
};
const onShowTopic = (type: number) => {
    if (!store.indexData.isLogin) {
        openLogin();
        return;
    }
    if (!schemaSupportMap.image_text_post_publish) {
        instance!.proxy.$toast('请升级至最新版本');
        return;
    }
    const item = topicConfig[type];
    schemaToPostPublish(item);
};
</script>
<style lang="scss">
.community-module {
    position: relative;
    &-content {
        position: absolute;
        top: 40px;
        left: 0;
        right: 0;
        bottom: 0;
    }

    :deep(.q-slogan) {
        padding: 10px 0;
    }
}
.activity-module {
    height: 1100px;
    padding: 0 80px;
    overflow: hidden;
    .title {
        margin: 0 -80px;
        position: relative;
        &-text {
            margin-top: 20px;
            font-size: 36px;
            color: #67492f;
            line-height: 52px;
            padding: 0 16px;
            position: relative;
            z-index: 2;
            font-weight: bold;
            &-2 {
                font-size: 24px;
                line-height: 34px;
                text-align: center;
            }
        }
        &-bg {
            position: absolute;
            left: 0;
            right: 0;
            top: -12px;
            margin: auto;
        }
        &-right {
            transform: rotate(180deg);
        }
    }
    .desc {
        margin-top: 28px;
        font-size: 28px;
        color: #67492f;
        line-height: 44px;
        text-align: justify;
        &-icon {
            display: inline-block;
            vertical-align: middle;
        }
    }
    .sub-title {
        font-weight: bold;
        margin-top: 30px;
        margin-bottom: 8px;
    }
    .text {
        font-size: 28px;
        color: #67492f;
        line-height: 40px;
    }
    .text-mark {
        color: #dc6a09;
    }
    .tip {
        margin-top: 12px;
        margin-bottom: 20px;
        font-size: 24px;
        color: #67492f;
        line-height: 34px;
    }
    .icon-activity-title {
        margin-top: 32px;
    }

    .type-item {
        margin-bottom: 16px;
        padding-right: 16px;
        border-radius: 16px;
        height: 92px;
        background: linear-gradient(93deg, #fff6ef 0%, rgba(255, 240, 229, 0.46) 100%);
        &-icon {
            margin-right: 14px;
        }
        &-title {
            font-weight: bold;
            font-size: 28px;
            color: #dd6a06;
            line-height: 42px;
        }
        &-tip {
            margin-top: 4px;
            font-size: 20px;
            color: rgba(103, 73, 47, 0.7);
            line-height: 30px;
        }
        &-btn {
            margin-left: auto;
            font-weight: bold;
            font-size: 24px;
            color: #5d402b;
            line-height: 34px;
        }
    }
}
</style>
